module.exports = __webpack_public_path__ + "static/media/bcbc.19d0b438.svg";